<template>
  <v-alert type="error" border="left" :elevation="3" :icon="icon">
    <p>Please check the following errors:</p>
    <ul>
      <li v-for="(error, index) in errors" :key="index">
        {{ error }}
      </li>
    </ul>
  </v-alert>
</template>

<script>
export default {
  name: "ValidationSummary",
  props: {
    icon: {
      type: [Boolean, String],
      required: false,
      default: false
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    }
  }
};
</script>

<style scoped></style>
